import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";
import { Header, Description } from "../../typo";

const SectionTopBase = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${select.space(5)};

  & > *:not(:last-child) {
    margin-right: ${select.space(3)};
  }
`;

const SectionTopMain = styled.div`
  flex-grow: 1;
`;

const SectionTopRight = styled.div`
  margin-left: ${select.space(3)};
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  title: string;
  description?: string;
  children?: any;
};

function SectionTop(
  { style, className, title, description, children }: Props,
  ref: any
) {
  return (
    <SectionTopBase ref={ref} style={style} className={className}>
      <SectionTopMain>
        <Header style={{ display: "block", marginBottom: 5 }}>{title}</Header>
        {description && (
          <Description style={{ display: "block" }}>{description}</Description>
        )}
      </SectionTopMain>
      {children && <SectionTopRight>{children}</SectionTopRight>}
    </SectionTopBase>
  );
}

export default React.forwardRef(SectionTop);
